import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {CustomAutocomplete} from '@ozgene/gp5.components.custom-autocomplete';
import {getStepLevels} from 'StepUpdateCreate/service/StepService';

export default function SelectStepLevel(props) {
  const {value, onChange, label, ...restProps} = props;
  const [stepLevels, setStepLevels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getOptionLabel = (level) => level.level;

  useEffect(() => {
    const handleRetrieveStepLevels = async () => {
      const newStepLevels = await getStepLevels();

      setStepLevels(newStepLevels);
      if (!value) {
        onChange(
          newStepLevels[newStepLevels.findIndex((st) => st.level === 'R1')],
        );
      }

      setIsLoading(false);
    };

    if (isLoading) {
      handleRetrieveStepLevels();
    }
  }, [isLoading]);

  return (
    !isLoading && (
      <CustomAutocomplete
        getOptionLabel={getOptionLabel}
        value={value}
        options={stepLevels}
        label={label}
        onChange={onChange}
        default
        {...restProps}
      />
    )
  );
}

SelectStepLevel.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    level: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectStepLevel.defaultProps = {
  value: null,
  label: 'Step Level',
};
